<template>
  <MasterDetail
    ref="masterDetail"
    :confirmDeleteMessage="confirmDeleteMessage"
    :cols="cols"
    :hasExportCSV="false"
    :hasExportXLSX="false"
    :opts="opts"
    :customResource="customResource"
    serverPagination
  ></MasterDetail>
</template>

<script>
import MasterDetail from "@/components/master-detail.vue";
import { mapGetters } from "vuex";
import { createServiceResource } from "@/api/ativacaoped/resource-adapter";
import businessUnitsDivisaoService from "@/api/ativacaoped/business-units-divisao.service";

export default {
  components: {
    MasterDetail
  },
  data() {
    return {
      opts: {}
    };
  },
  computed: {
    ...mapGetters(["clientId"]),
    cols() {
      return [
        {
          key: "nome",
          name: "Divisão",
          type: this.$fieldTypes.TEXT,
          rules: [{ rule: "required" }, { rule: "max", params: { size: 255 } }]
        }
      ];
    },
    /**
     * Resource service-backed consumido pelo `MasterDetail`
     * (`get` = grid/paginação, `save` = criar/editar, `delete` = excluir).
     * Substitui o `:resourceUrl`, que usava o `apiResource` inline do mixin.
     *
     * @returns {Object} Resource no contrato do `apiResource`
     */
    customResource() {
      // `clientId` é lido aqui (e não dentro dos handlers) de propósito: o
      // `MasterDetail` recarrega a grid pelo watcher de `customResource`, e o
      // computed precisa depender de `clientId` para refazer o `doLoad` quando
      // a empresa selecionada muda (mesmo comportamento do `resourceUrl`).
      const clientId = this.clientId;

      return createServiceResource({
        notify: this.notify,
        get: ({ query }) =>
          businessUnitsDivisaoService.getBusinessUnitsDivisao(clientId, query),
        save: (data, id) =>
          id
            ? businessUnitsDivisaoService.putBusinessUnitDivisao(clientId, id, data)
            : businessUnitsDivisaoService.postBusinessUnitDivisao(clientId, data),
        remove: id =>
          businessUnitsDivisaoService.deleteBusinessUnitDivisao(clientId, id)
      });
    }
  },
  created() {
    if (this.clientId === 0) {
      this.goToHome();
    }
  },
  watch: {
    clientId(value) {
      if (value === 0) {
        this.goToHome();
      }
    }
  },
  methods: {
    confirmDeleteMessage({ nome }) {
      return `Deseja excluir a divisão ${nome}?`;
    },
    goToHome() {
      this.notify({
        error: 'Não é possível acessar o módulo de Ativação P&D sem uma empresa selecionada.',
      });
      this.$router.push({ name: "homepage" });
    },
  }
};
</script>
